/**
 * Catalogos del PMIS extraidos del prototipo HTML.
 */

export const DISCIPLINAS = [
  "CIVIL",
  "MECÁNICA",
  "ELÉCTRICA",
  "INSTRUMENTACIÓN",
  "INTERVENTORIA",
  "GENERAL",
] as const;

export const ESTADOS_USUARIO = [
  "ACTIVO",
  "INACTIVO",
  "PENDIENTE_APROBACIÓN",
  "SUSPENDIDO",
] as const;

export const FASES_PROYECTO = [
  "Visualización BDG",
  "Ingeniería",
  "Planeación",
  "Abastecimientos",
  "Construcción",
  "Precomm",
  "Comm - PEM",
] as const;

export const MUDAS = [
  "Sobreproducción",
  "Inventario",
  "Movimiento",
  "Esperas",
  "Transporte",
  "Sobreprocesamiento",
  "Defectos / Reproceso",
  "Talento no aprovechado",
] as const;

/**
 * Clases de coste estandar Tecpetrol - Declaracion de Alcance VD §7.12.
 * Es el seed inicial del catalogo. La tabla CosteCatalogo en BD es la fuente
 * de verdad, ampliable por el JEFE / Administrador del PMIS desde el modulo
 * de configuracion.
 */
export const CLASES_COSTE = [
  { codigo: "A111001", nombre: "Ingenieria" },
  { codigo: "A111004", nombre: "Obras civiles" },
  { codigo: "A111005", nombre: "Montaje Electrico" },
  { codigo: "A111006", nombre: "Montaje Mecanico" },
  { codigo: "A2100001", nombre: "Materiales Electricos" },
  { codigo: "A210002", nombre: "Materiales Piping" },
  { codigo: "A210003", nombre: "Materiales Instrumentacion" },
  { codigo: "A210005", nombre: "Materiales civiles" },
  { codigo: "71100003", nombre: "Supervision de obras" },
  { codigo: "71100001", nombre: "Supervision en gestion ambiental" },
  { codigo: "80040003", nombre: "Movimiento de suelos para obra civil" },
  { codigo: "80010005", nombre: "Estudios topograficos y relevamiento" },
] as const;

/** Tipos de evento del RD. */
export const TIPOS_EVENTO = [
  "FOTO",
  "CALIDAD",
  "LEAN",
  "HSE",
  "LECCION",
  "SEG_FISICA",
  "AMBIENTAL",
] as const;
export type TipoEvento = (typeof TIPOS_EVENTO)[number];

/** Origen del personal en obra. */
export const ORIGEN_PERSONAL = ["Local", "Foraneo"] as const;
export type OrigenPersonal = (typeof ORIGEN_PERSONAL)[number];

/** Clase del personal en obra. */
export const CLASE_PERSONAL = ["STAFF", "MOC", "MONC"] as const;
export type ClasePersonal = (typeof CLASE_PERSONAL)[number];

/** Condicion del clima. */
export const CONDICION_CLIMA = [
  "Soleado",
  "Nublado",
  "Lluvia",
  "Tormenta",
  "Vientos fuertes",
] as const;
